var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"publiceTit"},[_c('div',{staticClass:"title"},[_c('p',{staticClass:"titleBg"},[_vm._v(_vm._s(_vm.titleObj.eng))]),_vm._v(" "),_c('p',{staticClass:"titleCon"},[_vm._v(_vm._s(_vm.titleObj.name))]),_vm._v(" "),_c('span',{staticClass:"line"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a69ca2a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/publiceTit/index.vue
// module id = null
// module chunks = 